module.exports = __webpack_public_path__ + "../resources/img/qr-android-pro.65ac4ae9.png";